import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22_app.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../../public/fonts/LibreCaslonCondensed-400.woff2%22,%22weight%22:%22400%22,%22style%22:%22normal%22},{%22path%22:%22../../public/fonts/LibreCaslonCondensed-400-italic.woff2%22,%22weight%22:%22400%22,%22style%22:%22italic%22},{%22path%22:%22../../public/fonts/LibreCaslonCondensed-500.woff2%22,%22weight%22:%22500%22,%22style%22:%22normal%22},{%22path%22:%22../../public/fonts/LibreCaslonCondensed-600.woff2%22,%22weight%22:%22600%22,%22style%22:%22normal%22}],%22display%22:%22swap%22,%22fallback%22:[%22Georgia%22,%22Times%20New%20Roman%22,%22serif%22]}],%22variableName%22:%22display%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'display', 'display Fallback', Georgia, Times New Roman, serif",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
